// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { NewContextMenuItemType } from '@shared/utils/ContextMenuUtils';
import { DataCache } from '../DataCache';
class _AccountMenuItemsHelper {
    GetDataToFillOut(selectedAccounts, isMultiSelect) {
        const accItems = [];
        const accounts = DataCache.getSortedAccountsArray(false, false);
        let isAddType = false;
        let accCounter = 0;
        const arrAccounts = [];
        const mapAccounts = {};
        for (const account of accounts) {
            const isSelected = selectedAccounts === null || selectedAccounts === void 0 ? void 0 : selectedAccounts.Contains(account);
            const accMenuItem = {
                type: NewContextMenuItemType.Account,
                value: account,
                canCheck: isMultiSelect,
                checked: isMultiSelect && isSelected,
                selected: !isMultiSelect && isSelected
            };
            const accUserLogin = account.userLogin;
            accItems.push(accMenuItem);
            if (isNullOrUndefined(mapAccounts[accUserLogin])) {
                mapAccounts[accUserLogin] = accUserLogin;
                arrAccounts.push(accUserLogin);
            }
            isAddType = isAddType || account.PreferredInstrumentType !== -1;
            accCounter++;
        }
        return new AccountMenuItemsHelperResult(accItems, isAddType, arrAccounts.length === 1, accCounter === 1);
    }
    createAccountMenuItems(selectedAccount, clickEvent) {
        const items = [];
        const accounts = DataCache.getSortedAccountsArray(false, false);
        if (accounts.length <= 1) {
            return items;
        }
        const users = new Set(accounts.map((account) => account.userLogin));
        if (users.size === 1) {
            for (let i = 0; i < accounts.length; i++) {
                const account = accounts[i];
                items.push({
                    type: NewContextMenuItemType.Account,
                    value: account,
                    selected: account === selectedAccount,
                    event: clickEvent
                });
            }
        }
        else {
            items.push({ type: NewContextMenuItemType.AccountLookup, value: selectedAccount });
        }
        return items;
    }
}
export const AccountMenuItemsHelper = new _AccountMenuItemsHelper();
export class AccountMenuItemsHelperResult {
    constructor(Items, IsAddType, IsOnlyOwnAccounts, IsSingleAccount) {
        this.Items = [];
        this.IsAddType = false;
        this.IsOnlyOwnAccounts = false;
        this.IsSingleAccount = false;
        this.Items = Items;
        this.IsAddType = IsAddType;
        this.IsOnlyOwnAccounts = IsOnlyOwnAccounts;
        this.IsSingleAccount = IsSingleAccount;
    }
}
